/* eslint-disable import/no-default-export */
import { token, memberId } from '@trello/session-cookie';
import { clientVersion } from '@trello/config';
import TrelloClient from './trello-client-js';
import { Analytics } from '@trello/atlassian-analytics';

function getDefaultHeaders() {
  return {
    'X-Trello-Client-Version': clientVersion,
    'X-Trello-ReqId': `${memberId}-${Math.random()}`,
    'X-Trello-Operation-Source': 'gamma',
    'X-Trello-Operation-Name': 'unknown',
    //X-Trello-PreferMember: will be necessary for "One Account", please check https://extranet.atlassian.com/display/TRELLO/One+Account%3A+Technical+Implementation+Specification+v2.0
  };
}

class API {
  client = new TrelloClient({
    getHeaders: () => getDefaultHeaders(),
    getToken: () => token || '',
  });

  withTracing = (traceId: string) => {
    return new TrelloClient({
      getHeaders: () => ({
        ...getDefaultHeaders(),
        ...Analytics.getTaskRequestHeaders(traceId),
      }),
      getToken: () => token || '',
    });
  };
}

// eslint-disable-next-line @trello/no-module-logic
export default new API();
